export const arrowNavigation = () => {
	const container = document.querySelector( '.masthead-lower__container' );
	const ulElement = container?.querySelector( 'ul' ); // Select the <ul> inside the container

	if ( ! container || ! ulElement ) {
		return;
	}

	const sendGTMTrackingData = ( elementClasses, directionClicked ) => {
		// Send data to GTM.
		window.dataLayer = window.dataLayer || [];
		dataLayer.push( {
			event: 'gtm.linkClick',
			gtm: {
				elementUrl: '#' + directionClicked,
				elementText: 'Arrow Direction - ' + directionClicked,
				elementTarget: '_self',
				willOpenInNewWindow: false,
				elementClasses: elementClasses,

			},
		} );
	};

	const togglePseudoElements = () => {
		const scrollLeft = ulElement.scrollLeft;
		const maxScrollLeft = ulElement.scrollWidth - ulElement.clientWidth;

		// Show &:before only if scrolled more than 15px from the left
		if ( scrollLeft > 15 ) {
			container.classList.add( 'show-before' );
		} else {
			container.classList.remove( 'show-before' );
		}

		// Show &:after only if scrolled more than 15px from the right
		if ( scrollLeft < maxScrollLeft - 15 ) {
			container.classList.add( 'show-after' );
		} else {
			container.classList.remove( 'show-after' );
		}
	};

	// Ensure &:after is visible by default
	container.classList.add( 'show-after' );

	// Initial check for pseudo-elements visibility
	togglePseudoElements();

	ulElement.addEventListener( 'scroll', togglePseudoElements);

	// Add click event listener to the container
	container.addEventListener( 'click', (event) => {
		// Get the bounding box of the container
		const rect = container.getBoundingClientRect();

		// Check if the click occurred in the left 50px area (where the :before pseudo-element is rendered)
		if ( event.clientX >= rect.left && event.clientX <= rect.left + 50 ) {
			ulElement.scrollLeft = Math.max( ulElement.scrollLeft - 100, 0 ); // Scroll the <ul> 100px to the left

			sendGTMTrackingData( '.masthead-lower__container.show-before::before', 'left' );
		}

		// Check if the click occurred in the right 50px area (where the :after pseudo-element is rendered)
		if ( event.clientX >= rect.right - 50 && event.clientX <= rect.right ) {
			ulElement.scrollLeft = Math.min(
				ulElement.scrollLeft + 100,
				ulElement.scrollWidth - ulElement.clientWidth
			); // Scroll the <ul> 100px to the right

			sendGTMTrackingData( '.masthead-lower__container.show-after::after', 'right' );
		}
	});
};
